import lodashGet from "lodash/get";
import moment from "moment-timezone";

const { Employer } = require("@services/all.services");

export async function fetchExportationData(filters) {
  const response = await Employer.getListEmployerToExport(filters);
  if (!response || !Array.isArray(response)) {
    return [];
  }

  const mappedData = response.map((employeeData) => {
    const actualSalary = employeeData.salaryAndAdvantages.find(
      (salary) => salary.isInProgress
    );

    const previousSalary = employeeData.salaryAndAdvantages.find(
      (salary) => !salary.isInProgress
    );

    const actualCourse = employeeData.emploiCourses.find(
      (emploiCourse) => emploiCourse.progress
    );
    const previousCourse = employeeData.emploiCourses.find(
      (emploiCourse) => !emploiCourse.progress
    );

    let holidaySolde = {};
    const hoursPerDay = employeeData.emploiSalary?.holiday?.hoursPerDay || 1;
    for (let solde of employeeData?.holidaySolde) {
      if (!solde?.holidayName?._id) {
        continue;
      }

      const isDayFormat = solde.holidayName.hourFormat === "days";

      holidaySolde[solde.holidayName._id] = {
        ...solde,
        hours: isDayFormat ? solde.hours : solde.hours * hoursPerDay,
        hoursRemaining: isDayFormat
          ? solde.hoursRemaining
          : solde.hoursRemaining * hoursPerDay
      };
    }

    return {
      ...employeeData,
      salaryAndAdvantages: employeeData.salaryAndAdvantages.map((salary) => ({
        ...salary,
        hourlyRate: `${+salary.hourlyRate || 0} ${salary.hourlyRateDevise}`,
        benefitType: Array.isArray(salary?.AdvantageType)
          ? salary.AdvantageType.map((advantage) => advantage?.name)
              .filter(Boolean)
              .join(", ")
          : "",
        benefitValue: Array.isArray(salary?.AdvantageType)
          ? salary.AdvantageType.map((advantage) => {
              const annualValue = advantage?.annualValue || "";
              const annualDevise = advantage?.annualDevise || "";

              return [annualValue, annualDevise].filter(Boolean).join(" ");
            })
              .filter(Boolean)
              .join(", ")
          : "",
        benefitesNotes: Array.isArray(salary?.AdvantageType)
          ? salary.AdvantageType.map((advantage) => advantage?.note)
              .filter(Boolean)
              .join(", ")
          : ""
      })),
      emploiCourses: employeeData.emploiCourses.map((emploiCourse) => ({
        ...emploiCourse,
        dateStart: formatDate(emploiCourse.dateStart),
        endDate: formatDate(emploiCourse.endDate)
      })),
      salaryData: {
        actualSalary: +actualSalary?.salary || 0,
        previousSalary: +previousSalary?.salary || 0
      },
      holidaySolde,
      emploiCourseData: {
        actualCourseName: actualCourse?.title || "",
        actualCourseStartDate: formatDate(actualCourse?.dateStart),
        previousCourseName: previousCourse?.title || "",
        previousCourseStartDate: formatDate(previousCourse?.dateStart),
        previousCourseEndDate: formatDate(previousCourse?.endDate)
      }
    };
  });

  return mappedData;
}

export function formatDate(date) {
  if (!date || !moment(date).isValid()) {
    return "";
  }

  return moment(moment.tz(date, "UTC").format("YYYY-MM-DD")).format("LL");
}

export function getExcelValue(employeeData, fieldInfo) {
  const fieldValue = lodashGet(employeeData, fieldInfo.value);

  if (!fieldInfo.isArray) {
    if (fieldInfo.isDate) {
      return formatDate(fieldValue);
    }

    return fieldValue || fieldInfo.defaultValue || "";
  }

  if (!fieldValue?.length) {
    return "";
  }

  if (!fieldInfo.isArrayOfObject) {
    return fieldValue.map((itm) => itm).join(", ");
  }

  if (fieldInfo.isDate) {
    return fieldValue
      .map((value) => formatDate(value[fieldInfo.attribut]))
      .filter((formattedDate) => Boolean(formattedDate))
      .join(", ");
  }

  return fieldValue
    .reduce(function (filtered, valueItem) {
      const subFieldValue = lodashGet(valueItem, fieldInfo.attribut);

      if (!subFieldValue && fieldInfo.defaultValue === undefined) {
        return filtered;
      }

      return filtered.concat(subFieldValue || fieldInfo.defaultValue);
    }, [])
    .join(", ");
}
